// Simple toast notification system
class ToastManager {
  constructor () {
    this.container = null
    this.toasts = []
  }

  init () {
    if (this.container) return

    this.container = document.createElement('div')
    this.container.className = 'toast-container'
    document.body.appendChild(this.container)
  }

  show (message, type = 'info', duration = 3000) {
    this.init()

    const toast = document.createElement('div')
    toast.className = `toast toast-${type} toast-enter`

    const icon = this.getIcon(type)
    toast.innerHTML = `
      <div class="toast-icon">${icon}</div>
      <div class="toast-message">${message}</div>
    `

    this.container.appendChild(toast)

    // Trigger animation
    setTimeout(() => {
      toast.classList.remove('toast-enter')
      toast.classList.add('toast-visible')
    }, 10)

    // Auto remove
    setTimeout(() => {
      this.remove(toast)
    }, duration)

    return toast
  }

  remove (toast) {
    toast.classList.remove('toast-visible')
    toast.classList.add('toast-exit')

    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast)
      }
    }, 300)
  }

  getIcon (type) {
    const icons = {
      success: '✓',
      error: '✕',
      warning: '⚠',
      info: 'ℹ'
    }
    return icons[type] || icons.info
  }

  success (message, duration) {
    return this.show(message, 'success', duration)
  }

  error (message, duration) {
    return this.show(message, 'error', duration)
  }

  warning (message, duration) {
    return this.show(message, 'warning', duration)
  }

  info (message, duration) {
    return this.show(message, 'info', duration)
  }
}

export const toast = new ToastManager()
